import { render, staticRenderFns } from "./AssistKb.vue?vue&type=template&id=13cf10ee"
import script from "./AssistKb.vue?vue&type=script&lang=js"
export * from "./AssistKb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports